import React from "react";
import { MOCK_ORDERS } from "../../data/mock";
import { StatusBadge } from "./CustomerHome";

const STEPS = ["Order placed", "File received", "Printing", "Quality check", "Out for delivery", "Delivered"];

export default function CustomerTrack() {
  const active = MOCK_ORDERS.find((o) => o.status !== "delivered") || MOCK_ORDERS[0];
  const currentIndex = active.status === "printing" ? 2 : active.status === "ready" ? 4 : active.status === "delivered" ? 5 : 0;

  return (
    <div data-testid="customer-track">
      <h1 className="font-display text-3xl font-bold">Track your order</h1>

      <div className="mt-4 rounded-lg border border-neutral-200 bg-white p-5">
        <div className="flex flex-wrap items-center justify-between gap-2">
          <div>
            <div className="font-mono text-xs text-neutral-500">{active.id}</div>
            <div className="mt-1 font-display text-lg font-bold">{active.product}</div>
            <div className="text-xs text-neutral-500">{active.customer} · {active.location}</div>
          </div>
          <div className="text-right">
            <div className="font-mono text-lg font-bold">₹{active.amount.toLocaleString("en-IN")}</div>
            <StatusBadge status={active.status} />
          </div>
        </div>

        <ol className="mt-6 space-y-4" data-testid="track-timeline">
          {STEPS.map((s, i) => {
            const done = i < currentIndex;
            const current = i === currentIndex;
            return (
              <li key={s} className="flex items-start gap-3" data-testid={`track-step-${i}`}>
                <div className={`mt-0.5 flex h-5 w-5 items-center justify-center rounded-full ${done ? "bg-lime-500" : current ? "bg-lime-400 pulse-dot" : "bg-neutral-200"}`}>
                  <span className={`h-2 w-2 rounded-full ${done || current ? "bg-neutral-950" : "bg-neutral-400"}`} />
                </div>
                <div>
                  <div className={`text-sm font-semibold ${done || current ? "text-neutral-950" : "text-neutral-400"}`}>{s}</div>
                  {current && <div className="text-xs text-neutral-500">Estimated: {active.eta}</div>}
                </div>
              </li>
            );
          })}
        </ol>
      </div>
    </div>
  );
}
